import { WEB_URL } from "@/config/endpoints";
import IMAGES from "@/public/assets/img";


export default {
  SeoContent:{
    title: "Compradoras global",
    url: WEB_URL+'/es-mx/global-buyer',
    description:'Panel de control de compradores globales | Información de datos en tiempo real',
    keyword: 'Financiación de la cadena de suministro, cadena de suministro en las finanzas, empresa de financiación de la cadena de suministro', 
    imagePath:IMAGES.HOMEIMG.bigLogoNew.src
  },
  HomeNewData: {
    mainHeading: `<span class="font-normal text-heading1 sm:text-heading3 leading-[44px]">Financia a tus </span> <span class="font-medium text-heading1 sm:text-heading3 leading-[44px]">proveedores</span>`,
    text: "sin demoras con Credlix y <br /> fortalece la <span style='color:#00AFFF;'>relación comercial.</span>",
  },
  Dashboard: {
    mainHeading:
      "Gana control con un panel de comprador inteligente en tiempo real​",
    imagePath: IMAGES?.globalBuyer?.buyersDashboardES,
  },
  sliderMainHeading: {
    heading: "Desbloquea<span style='color:#B2B1B1'> soluciones de financiamiento flexibles como <br/> comprador para mejorar la relación con tus proveedores.</span>",
    subHeading: "Asegura la estabilidad de la cadena de suministro con financiamiento rápido y sin <br/> garantías para tus necesidades de importación y exportación."
  },
  posts: [
    {
      id: 1,
      title: "Impulsa el flujo de efectivo y fortalece tu negocio",
    },
    {
      id: 2,
      title: "Construye alianzas sólidas y duraderas con tus proveedores​",
    },
    {
      id: 3,
      title: "Estabilidad de la cadena de suministro",
    },
    {
      id: 4,
      title: "Eficiencia operativa",
    },
  ],
  SliderBuyerHeading: {
    Heading:
      "<span style='color:black;'>Desbloquea</span> soluciones de financiamiento flexibles como <br/> comprador para mejorar la relación con tus proveedores.",
    subHeading:
      "Asegura la estabilidad de la cadena de suministro con financiamiento rápido y sin <br/>garantías para tus necesidades de importación y exportación.",
  },

  sliderBuyer: [
    {
      id: 1,
      image: IMAGES.globalBuyer.benefitsBuyers,
      // BenefitsHeading: "Impulsa el flujo de efectivo y fortalece tu negocio",
      BenefitsPayments: "Pagos rápidos: ",
      BenefitsPaymentsDesc:
        "Los proveedores obtienen pagos instantáneos después de la entrega, lo que permite una rápida reinversión y aprovechamiento del arbitraje (Aprovechando las diferencias de precios entre mercados)​.",
      BenefitsFinancial: "Menor tensión financiera:",
      BenefitsFinancialDesc:
        "El descuento de facturas mejora la liquidez, ayudando a los proveedores a optimizar los precios de mercado.",
    },
    {
      id: 2,
      image: IMAGES.globalBuyer.relationshipBuyersES,
      // BenefitsHeading: "Construye alianzas sólidas y duraderas con tus proveedores",
      BenefitsPayments: "Confianza y confiabilidad : ",
      BenefitsPaymentsDesc:
        "Los compradores que utilizan el descuento de facturas muestran su compromiso con el bienestar financiero de los proveedores, fomentando vínculos más fuertes",
      BenefitsFinancial: "Mayor poder de negociación:",
      BenefitsFinancialDesc:
        "Los proveedores con un fuerte flujo de caja pueden ofrecer descuentos, negociar mejores condiciones y mantener precios estables.",
    },
    {
      id: 3,
      image: IMAGES.globalBuyer.stabilityBuyers,
      // BenefitsHeading: "Estabilidad de la cadena de suministro",
      BenefitsPayments: "Continuidad del suministro:",
      BenefitsPaymentsDesc:
        "El flujo de caja estable del proveedor evita interrupciones y garantiza entregas oportunas",
      BenefitsFinancial: "Riesgo reducido de quiebra del proveedor:",
      BenefitsFinancialDesc:
        "Los pagos instantáneos reducen los riesgos de insolvencia y protegen su cadena de suministro",
    },
    {
      id: 4,
      image: IMAGES.globalBuyer.efficiencyBuyers,
      // BenefitsHeading: "Eficiencia operativa",
      BenefitsPayments: "Operaciones simplificadas:",
      BenefitsPaymentsDesc:
        "El factoring gestiona los pagos, permitiendo a los proveedores centrarse en las tareas principales",
      BenefitsFinancial: "Costos más bajos para los proveedores:",
      BenefitsFinancialDesc:
        "El factoring cuesta menos que los préstamos, lo que mejora los precios y las condiciones para los compradores",
    },
  ],

  BenefitsHeading: {
    heading: "Beneficios para compradores y proveedores",
  },
  // sections: [
  //   {
  //     title: "Benefits for Buyer",
  //     backgroundColor: "bg-yellow-100",
  //     items: [
  //       {
  //         icon: IMAGES?.globalBuyer?.checkboxBuyers,
  //         title: "Support your Suppliers",
  //         description: "Strengthen relationships by securing required capital.",
  //       },
  //       {
  //         icon: IMAGES?.globalBuyer?.checkboxBuyers,
  //         title: "Maintain Control",
  //         description: "Continue to pay on your terms.",
  //       },
  //     ],
  //   },
  // ],

  sections: [
    {
      title: "Beneficios para compradores",
      backgroundColor: "bg-yellow-100",
      items: [
        {
          icon: IMAGES?.globalBuyer?.checkboxBuyers,
          title: "Apoya a tus proveedores",
          description:
            "Fortalece las relaciones asegurando el capital necesario.",
        },
        {
          icon: IMAGES?.globalBuyer?.checkboxBuyers,
          title: "Mantén el control",
          description: "Continúa pagando según tus términos..",
        },
      ],
    },
  ],
  sections2: [
    {
      title: "Beneficios para el proveedor",
      backgroundColor: "bg-teal-100",
      items: [
        {
          icon: IMAGES?.globalBuyer?.checkboxBuyers,
          title: "Términos flexibles",
          description:
            "Haga coincidir los pagos con las necesidades comerciales.",
        },
        {
          icon: IMAGES?.globalBuyer?.checkboxBuyers,
          title: "No más perseguir pagos",
          description: "Deje que Credlix administre el proceso de cobranza.",
        },
        {
          icon: IMAGES?.globalBuyer?.checkboxBuyers,
          title: "Pago Inmediato",
          description: "Acceda al efectivo tan pronto como emita una factura.",
        },
      ],
    },
  ],

  solutionsSec: {
    heading: "Transforma tu flujo de efectivo con Credlix",
    solutions: [
      {
        heading: "Factoraje de Exportación",
        paragraph:
          "Accede a factoraje sin recurso por hasta el 90% del valor de tu factura en más de 90 países, por hasta 120 días.",
        src: IMAGES.globalBuyer.exportBuyer,
        href: "/export-factoring",
        learnmoreCta : 'Saber más',
      },
      {
        heading: "Financiamiento de la cadena de suministro:",
        paragraph:
          "Fortalece las relaciones con los proveedores con financiamiento oportuno.",
        src: IMAGES.globalBuyer.financeBuyer,
        href: "/",
        learnmoreCta : 'Saber más',
      },
      {
        heading: "Pagos inmediatos y sin garantías:",
        paragraph: "Obtén fondos de hasta $5M al instante, sin garantías.",
        src: IMAGES.globalBuyer.paymentBuyer,
        href: "/export-factoring",
        learnmoreCta : 'Saber más',
      },
    ],
  },

  steps: [
    {
      number: "01",
      title: "Login Credentials",
      details: ["Email", "Password"],
    },
    {
      number: "02",
      title: "Select Supplier from Drop down list",
      details: ["Supplier list has to be uploaded on the portal."],
    },
    {
      number: "03",
      title: "Details Entry",
      details: [
        "Invoice No.",
        "Invoice Value",
        "Invoice Amount",
        "Funding Amount",
      ],
    },
    {
      number: "04",
      title: "Payment Terms",
      details: ["1. Payment term as per Invoice", "2. Requested Payment term"],
    },
    {
      number: "05",
      title: "Invoice Upload",
      details: ["Digital copy of Invoice need to be uploaded"],
    },
    {
      number: "06",
      title: "Submit for Payment",
      details: [],
    },
  ],

  BuyerPayment: {
    imagePath: IMAGES?.globalBuyer?.arrowBuyersDesktopES,
    imagePathMob: IMAGES?.globalBuyer?.arrowBuyersMobileES,
  },

  Faq_heading: "Preguntas Frecuentes (FAQ's)",
  Home_Faq: [
    {
      id: 0,
     question: "¿Qué es el descuento de facturas o factoring?​",
     answers: "Los proveedores reciben el pago anticipado de facturas a través de una empresa de factoraje. La empresa paga un porcentaje por adelantado y los compradores les reembolsan en la fecha de vencimiento.​",
    },
    {
      id: 1,
     question: "¿Cómo me beneficia el descuento de facturas como comprador?​",
     answers: "Ayuda a los proveedores con su flujo de efectivo, fortaleciendo las relaciones, reduciendo los riesgos en la cadena de suministro y potencialmente mejorando los términos y precios.​",
    },
    {
      id: 2,
     question: "¿Cuál es el costo del descuento de facturas para los compradores?​",
     answers: "Hay una tarifa cobrada por la empresa de factoring, generalmente un pequeño porcentaje de la factura. Los costos varían según la empresa y los términos.​",
    },
    {
      id: 3,
     question: "¿Cómo afecta el descuento de facturas a mi flujo de efectivo?​",
     answers: "No afecta directamente a tu flujo de efectivo. Pagas a la empresa de factoraje en la fecha de vencimiento, lo que ayuda a estabilizar tu cadena de suministro.​",
    },
    {
      id: 4,
     question: "¿Afectará el descuento de facturas mi relación con los proveedores?​",
     answers: "Puede mejorar las relaciones al apoyar la estabilidad de los proveedores, lo que lleva a mejores asociaciones y términos de negociación.​",
    },
    {
      id: 5,
     question: "¿Cómo puedo comenzar con el descuento de facturas para mis proveedores?​",
     answers: "Contacta a una empresa de factoraje para discutir las opciones y establecer un acuerdo.​",
    },
    {
      id: 6,
     question: "¿Existen riesgos involucrados en el descuento de facturas?​",
     answers: "TEl principal riesgo es el impacto potencial en las relaciones con los clientes debido a la gestión del cobro de pagos. Muchas empresas ofrecen servicios discretos para manejar esto.​",
    },
    {
      id: 7,
     question: "¿Puedo elegir qué facturas descontar?​",
     answers: "Sí, puedes seleccionar qué facturas descontar según tus necesidades y acuerdos.​",
    },
    {
      id: 8,
     question: "¿Cómo afectará el descuento de facturas a mis estados financieros?​",
     answers: "Aparece como un pasivo o gasto en tus estados financieros, pero no afecta directamente los ingresos.​",
    },
    {
      id: 9,
     question: "¿Se puede utilizar el descuento de facturas para todos los proveedores?",
     answers: "Sí, siempre que los proveedores estén de acuerdo y la empresa de factoring acepte las facturas.​",
    },
  ],
  country_Name: [
    {
      id: 1,
      name: "Andorra",
      code: "376",
    },
    {
      id: 2,
      name: "Aruba",
      code: "297",
    },
    {
      id: 3,
      name: "Australia",
      code: "61",
    },
    {
      id: 4,
      name: "Austria",
      code: "43",
    },
    {
      id: 5,
      name: "Bélgica",
      code: "32",
    },
    {
      id: 6,
      name: "Botsuana",
      code: "267",
    },
    {
      id: 7,
      name: "Brasil",
      code: "55",
    },
    {
      id: 8,
      name: "Bulgaria",
      code: "359",
    },
    {
      id: 9,
      name: "Canadá",
      code: "1",
    },
    {
      id: 10,
      name: "Chile",
      code: "56",
    },
    {
      id: 11,
      name: "China",
      code: "86",
    },
    {
      id: 12,
      name: "Croacia",
      code: "385",
    },
    {
      id: 13,
      name: "Chipre",
      code: "357",
    },
    {
      id: 14,
      name: "República Checa",
      code: "420",
    },
    {
      id: 15,
      name: "Dinamarca",
      code: "45",
    },
    {
      id: 16,
      name: "Estonia",
      code: "372",
    },
    {
      id: 17,
      name: "Finlandia",
      code: "358",
    },
    {
      id: 18,
      name: "Francia",
      code: "33",
    },
    {
      id: 19,
      name: "Alemania",
      code: "49",
    },
    {
      id: 20,
      name: "Grecia",
      code: "30",
    },
    {
      id: 21,
      name: "Hungría",
      code: "36",
    },
    {
      id: 22,
      name: "Islandia",
      code: "354",
    },
    {
      id: 23,
      name: "India",
      code: "91",
    },
    {
      id: 24,
      name: "Indonesia",
      code: "62",
    },
    {
      id: 25,
      name: "Irlanda",
      code: "353",
    },
    {
      id: 26,
      name: "Israel",
      code: "972",
    },
    {
      id: 27,
      name: "Italia",
      code: "39",
    },
    {
      id: 28,
      name: "Japón",
      code: "81",
    },
    {
      id: 29,
      name: "Kazajistán",
      code: "7",
    },
    {
      id: 30,
      name: "Kuwait",
      code: "965",
    },
    {
      id: 31,
      name: "Letonia",
      code: "371",
    },
    {
      id: 32,
      name: "Lituania",
      code: "370",
    },
    {
      id: 33,
      name: "Luxemburgo",
      code: "352",
    },
    {
      id: 34,
      name: "Malasia",
      code: "60",
    },
    {
      id: 35,
      name: "Malta",
      code: "356",
    },
    {
      id: 36,
      name: "Mauricio",
      code: "230",
    },
    {
      id: 37,
      name: "México",
      code: "52",
    },
    {
      id: 38,
      name: "Montserrat",
      code: "1664",
    },
    {
      id: 39,
      name: "Países Bajos",
      code: "31",
    },
    {
      id: 40,
      name: "Nueva Zelanda",
      code: "64",
    },
    {
      id: 41,
      name: "Noruega",
      code: "47",
    },
    {
      id: 42,
      name: "Panamá",
      code: "507",
    },
    {
      id: 43,
      name: "Perú",
      code: "51",
    },
    {
      id: 44,
      name: "Filipinas",
      code: "63",
    },
    {
      id: 45,
      name: "Polonia",
      code: "48",
    },
    {
      id: 46,
      name: "Portugal",
      code: "351",
    },
    {
      id: 47,
      name: "Catar",
      code: "974",
    },
    {
      id: 48,
      name: "Rumania",
      code: "40",
    },
    {
      id: 49,
      name: "Santa Elena",
      code: "290",
    },
    {
      id: 50,
      name: "Arabia Saudita",
      code: "966",
    },
    {
      id: 51,
      name: "Serbia",
      code: "381",
    },
    {
      id: 52,
      name: "Singapur",
      code: "65",
    },
    {
      id: 53,
      name: "Eslovaquia",
      code: "421",
    },
    {
      id: 54,
      name: "Eslovenia",
      code: "386",
    },
    {
      id: 55,
      name: "Corea del Sur",
      code: "82",
    },
    {
      id: 56,
      name: "España",
      code: "34",
    },
    {
      id: 57,
      name: "Suecia",
      code: "46",
    },
    {
      id: 58,
      name: "Suiza",
      code: "41",
    },
    {
      id: 59,
      name: "Taiwán",
      code: "886",
    },
    {
      id: 60,
      name: "Tailandia",
      code: "66",
    },
    {
      id: 61,
      name: "Trinidad y Tobag",
      code: "1868",
    },
    {
      id: 62,
      name: "Islas Urcas y Caicos",
      code: "1649",
    },
    {
      id: 63,
      name: "Emiratos Árabes Unidos",
      code: "971",
    },
    {
      id: 64,
      name: "Reino Unido",
      code: "44",
    },
    {
      id: 65,
      name: "Estados Unidos",
      code: "1",
    },
    {
      id: 66,
      name: "Uruguay",
      code: "598",
    },
  ],

  FormData: {
    Heading: "<span style='font-weight:400;'>Financia </span>&nbsp;tus proveedores",
    Company: "Nombre de la Empresa*",
    Email: "Correo electrónic*",
    CountryName:'País*',
    Country: "País*",
    Mobile: "Número de teléfono móvil*",
    SelectFunding: "Selecciona Necesidad de Financiamiento*",
    Submitbtn: "Asegura el Financiamiento Ahora",
    ThankYou: "Envío exitoso: Gracias por su interés.",
    requiredMessage: "Este campo es obligatorio.",
    emailMessage: "Correo electrónico no válido",
    phoneMessage: "El número de teléfono no es válido",
  },
};
